import "../../css/Pulse.css";

function Pulse() {
  return <div className="pulse-spinner"></div>;
}

export default Pulse;
